import axios from 'axios';
import { ladeToken, loescheAuth } from 'core/features/auth/authApi';

/**
 * Axios-Client fuer die TODO-API (`/api/todos`). nginx leitet `/api/*` (Catch-all)
 * an den api-service weiter. Alle Endpunkte sind nutzerbezogen und per JWT geschuetzt;
 * die Antworten sind rohe DTOs (kein ApiResponse-Wrapper).
 */
const todoApi = axios.create({
  baseURL: '/api',
  timeout: 15000,
});

// Haengt das JWT an jede Anfrage (Todos sind geschuetzt).
todoApi.interceptors.request.use((config) => {
  const token = ladeToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Bei 401 (Token fehlt/abgelaufen) abmelden und zur Login-Seite leiten.
todoApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      loescheAuth();
      if (window.location.pathname !== '/login') {
        window.location.assign('/login');
      }
    }
    return Promise.reject(error);
  }
);

const data = (response) => response.data;

// ── Aufgaben ────────────────────────────────────────────
export const fetchTodosApi = () => todoApi.get('/todos').then(data);

export const createTodoApi = (todo) => todoApi.post('/todos', todo).then(data);

export const updateTodoApi = (uuid, todo) => todoApi.put(`/todos/${uuid}`, todo).then(data);

export const deleteTodoApi = (uuid) => todoApi.delete(`/todos/${uuid}`).then(() => uuid);

export const createTodoFromVorlageApi = (vorlageUuid) =>
  todoApi.post(`/todos/aus-vorlage/${vorlageUuid}`).then(data);

// ── Kategorien ──────────────────────────────────────────
export const fetchKategorienApi = () => todoApi.get('/todos/kategorien').then(data);

export const createKategorieApi = (kategorie) =>
  todoApi.post('/todos/kategorien', kategorie).then(data);

export const updateKategorieApi = (uuid, kategorie) =>
  todoApi.put(`/todos/kategorien/${uuid}`, kategorie).then(data);

export const deleteKategorieApi = (uuid) =>
  todoApi.delete(`/todos/kategorien/${uuid}`).then(() => uuid);

// ── Vorlagen ────────────────────────────────────────────
export const fetchVorlagenApi = () => todoApi.get('/todos/vorlagen').then(data);

export const createVorlageApi = (vorlage) =>
  todoApi.post('/todos/vorlagen', vorlage).then(data);

export const updateVorlageApi = (uuid, vorlage) =>
  todoApi.put(`/todos/vorlagen/${uuid}`, vorlage).then(data);

export const deleteVorlageApi = (uuid) =>
  todoApi.delete(`/todos/vorlagen/${uuid}`).then(() => uuid);

export default todoApi;
